import LangEnum from '../../../lang/LangEnum';
import useTargetValueFormatter from '../../target/hooks/useTargetValueFormatter';
import { TARGET_EMPTY_VALUE } from '../../target/target.constants';
import { useTranslation } from '../../translation/TranslationContext';
import { OrderTargetAmounts, UseOrderTargetListItemParams } from './orderTargets.types';

const useOrderTargetListItem = ({
  code,
  unit,
  attainedValue,
  plannedValue,
  breakdown,
}: UseOrderTargetListItemParams) => {
  const { translate } = useTranslation();
  const { formatAbreviatedValue } = useTargetValueFormatter(unit);

  const toAmountsLabel = (amounts: OrderTargetAmounts) =>
    translate(LangEnum.GLOBAL_FROM_VALUE, {
      minValue: formatAbreviatedValue(amounts.attainedValue),
      maxValue: formatAbreviatedValue(amounts.plannedValue),
    });

  const breakdownRows = breakdown.items.map((item) => ({
    id: item.id,
    attainment: item.attainment,
    label: item.label ?? TARGET_EMPTY_VALUE,
    amountsLabel: toAmountsLabel(item),
  }));

  return {
    title: `${translate(LangEnum.GLOBAL_PLAN)} ${code}`,
    attainmentLabel: toAmountsLabel({ attainedValue, plannedValue }),
    breakdownRows,
    viewOnOrderLabel: translate(LangEnum.GLOBAL_VIEW_ON_ORDER),
  };
};

export default useOrderTargetListItem;
